// ============================================================================
// post-client-mod -- usePosts Hook
//
// 获取当前用户的文章列表，支持分页和状态过滤。
// 支持 SSR：如果传入 initialData，直接使用（不请求）。
// ============================================================================
import { useState, useEffect, useCallback, useRef } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 获取文章列表
 */
export function usePosts(params) {
    const initialData = params?.initialData;
    // 如果有 initialData，直接使用
    const [posts, setPosts] = useState(initialData?.data ?? []);
    const [pagination, setPagination] = useState(initialData?.pagination ?? null);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(params?.page ?? 1);
    // 使用 useRef 追踪首次渲染，在 SSR hydration + 纯 CSR 场景下都可靠
    const isFirstRender = useRef(true);
    const fetchPosts = useCallback(async () => {
        // 首次渲染时如果有 initialData，跳过请求（SSR hydration 场景）
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (initialData)
                return;
        }
        setLoading(true);
        setError(null);
        try {
            const result = await getPostApiClient().getPosts({
                page,
                pageSize: params?.pageSize ?? 10,
                status: params?.status,
                authorId: params?.authorId,
                categorySlug: params?.categorySlug,
                tagSlugs: params?.tagSlugs,
                q: params?.q,
            });
            setPosts(result.data);
            setPagination(result.pagination);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取文章列表失败';
            setError(message);
            setPosts([]);
            setPagination(null);
        }
        finally {
            setLoading(false);
        }
    }, [page, params?.status, params?.authorId, params?.categorySlug, params?.tagSlugs, params?.q, params?.pageSize, initialData]);
    useEffect(() => {
        fetchPosts();
    }, [fetchPosts]);
    return {
        posts,
        pagination,
        loading,
        error,
        refresh: fetchPosts,
        setPage,
    };
}
//# sourceMappingURL=use-posts.js.map